import { render } from "./detail.vue?vue&type=template&id=1cbbb165&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts&config=true"
export * from "./detail.vue?vue&type=script&lang=ts&config=true"

import "./detail.vue?vue&type=style&index=0&id=1cbbb165&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbbb165"]])

export default __exports__